"use client";
import { useAuth } from "@ctv/core";
import AuthLoading from "@ctv/core/auth/AuthLoading";
import FlaggedUserError from "@ctv/core/auth/components/FlaggedUserError";
import { FC_COMPROMISED_PASSWORD } from "@ctv/core/feature-control/constants";
import useFeatureControlSegmentation from "@ctv/core/feature-control/hooks";
import BMView from "@ctv/shared-core/src/components/View/BMView";
import { MultiFactorError, MultiFactorOtp } from "@ctv/shared-core/src/mobile";
import { PropsWithChildren } from "react";
import { StyleSheet } from "react-native";
import { useCheckMFAGateway } from "../../_hooks/useCheckMFAGateway";

export default function MobileCheckMfaGateway({
  children,
}: PropsWithChildren<unknown>) {
  const {
    data: { data, isByPass, errorMessage },
    refOtp,
    isSubmitting,
    onSendOtp,
    onSubmitOtp,
  } = useCheckMFAGateway();

  const { user, logout } = useAuth();

  const { enabled: isEnabledCompromisedPasswordCheck } =
    useFeatureControlSegmentation(FC_COMPROMISED_PASSWORD);

  function onClickLogo() {
    logout();
  }

  if (data === undefined) {
    return <AuthLoading />;
  }

  if (data === null) {
    return (
      <BMView style={styles.container} flex justify="center" align="center">
        <MultiFactorError onRefresh={() => window.location.reload()} />
      </BMView>
    );
  }

  if (isEnabledCompromisedPasswordCheck && data.flagged) {
    return <FlaggedUserError />;
  }

  if (!data.mfaGate || isByPass) {
    return <>{children}</>;
  }

  return (
    <BMView style={styles.container} flex justify="start">
      <BMView style={styles.wrapper}>
        <MultiFactorOtp
          email={user?.email || ""}
          ref={refOtp}
          isLoading={isSubmitting}
          errorMessage={errorMessage}
          onSubmit={onSubmitOtp}
          onResendOtp={onSendOtp}
          onClickLogo={onClickLogo}
        />
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    position: "relative",
  },
  wrapper: {
    // @ts-ignore
    marginTop: "calc(100vh * 0.15)",
  },
});
